import { render, staticRenderFns } from "./LastPolls.vue?vue&type=template&id=726c4ff4&scoped=true&"
import script from "./LastPolls.vue?vue&type=script&lang=js&"
export * from "./LastPolls.vue?vue&type=script&lang=js&"
import style0 from "./LastPolls.vue?vue&type=style&index=0&id=726c4ff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726c4ff4",
  null
  
)

export default component.exports